/* panthure.dk — Hiform Denmark interactive theme script */
(function () {
  'use strict';

  const PT = window.Panthure = window.Panthure || {};

  /* ---------- i18n + money ---------- */
  const I18N = (window.HiformI18n && window.HiformI18n.cart) || {};
  const T = function (key, vars) {
    let s = I18N[key] || '';
    if (vars) Object.keys(vars).forEach(k => { s = s.replace('{{ ' + k + ' }}', vars[k]).replace('__' + k.toUpperCase() + '__', vars[k]); });
    return s;
  };

  PT.money = function (cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney && window.HiformMoney) {
      try { return Shopify.formatMoney(cents, window.HiformMoney); } catch (e) {}
    }
    // Fallback: use Intl with the active currency
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: cur, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  };

  /* ---------- Toast (errors) ---------- */
  PT.toast = function (msg, kind) {
    if (!msg) return;
    let host = document.querySelector('.pt-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.className = 'pt-toast-host';
      document.body.appendChild(host);
    }
    const el = document.createElement('div');
    el.className = 'pt-toast pt-toast--' + (kind || 'info');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    host.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-in'));
    setTimeout(() => {
      el.classList.remove('is-in');
      setTimeout(() => el.remove(), 350);
    }, 4000);
  };

  /* ---------- Cart fetch / mutate ---------- */
  PT.fetchCart = function () {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
  };

  PT.updateCartItem = function (key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)));
  };

  PT.addToCart = function (variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)));
  };

  /* ---------- Cart drawer ---------- */
  PT.Drawer = {
    el: null,
    body: null,
    open() {
      this.el && this.el.setAttribute('data-open', 'true');
      document.body.classList.add('pt-no-scroll');
      this.refresh();
    },
    close() {
      this.el && this.el.setAttribute('data-open', 'false');
      document.body.classList.remove('pt-no-scroll');
    },
    toggle() {
      if (!this.el) return;
      this.el.getAttribute('data-open') === 'true' ? this.close() : this.open();
    },
    refresh() {
      if (!this.body) return;
      PT.fetchCart().then(cart => this.render(cart));
    },
    render(cart) {
      PT.updateCartBubble(cart.item_count);
      const empty = this.el.querySelector('[data-pt-cart-empty]');
      const full = this.el.querySelector('[data-pt-cart-full]');
      const foot = this.el.querySelector('[data-pt-cart-footer]');
      if (cart.item_count === 0) {
        empty && (empty.style.display = 'flex');
        full && (full.style.display = 'none');
        foot && (foot.style.display = 'none');
        return;
      }
      empty && (empty.style.display = 'none');
      full && (full.style.display = 'flex');
      foot && (foot.style.display = 'block');

      const list = this.el.querySelector('[data-pt-cart-items]');
      if (list) {
        list.innerHTML = cart.items.map(item => this.itemTpl(item)).join('');
      }

      const subtotal = this.el.querySelector('[data-pt-cart-subtotal]');
      if (subtotal) subtotal.textContent = PT.money(cart.total_price, cart.currency);

      const free = this.el.querySelector('[data-pt-cart-freeship]');
      if (free) {
        const threshold = parseInt(free.getAttribute('data-threshold'), 10) || 5000;
        const remaining = threshold - cart.total_price;
        const progress = free.querySelector('[data-pt-progress]');
        const bar = free.querySelector('.pt-freeship__bar');
        const msg = free.querySelector('[data-pt-freeship-msg]');
        const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        if (progress) progress.style.width = pct + '%';
        if (bar) bar.setAttribute('aria-valuenow', pct);
        if (msg) {
          if (remaining <= 0) {
            msg.innerHTML = T('freeship_won') || '✓ Free shipping unlocked';
          } else {
            const tpl = T('freeship_remaining') || 'Add <strong>{{ amount }}</strong> for free shipping';
            msg.innerHTML = tpl.replace('{{ amount }}', PT.money(remaining)).replace('__AMOUNT__', PT.money(remaining));
          }
        }
      }
    },
    itemTpl(item) {
      const safe = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      const imgUrl = item.image ? String(item.image).replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_120x$1$2') : '';
      const img = item.image
        ? `<img src="${safe(imgUrl)}" alt="${safe(item.product_title)}" loading="lazy" />`
        : '<div class="pt-cart-item__placeholder"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="pt-cart-item__variant">${safe(item.variant_title)}</span>` : '';
      const dec = T('decrease') || 'Decrease';
      const inc = T('increase') || 'Increase';
      const rem = T('remove') || 'Remove';
      return `
        <article class="pt-cart-item" data-key="${safe(item.key)}">
          <a class="pt-cart-item__media" href="${safe(item.url)}">${img}</a>
          <div class="pt-cart-item__body">
            <a class="pt-cart-item__title" href="${safe(item.url)}">${safe(item.product_title)}</a>
            ${variant}
            <div class="pt-cart-item__row">
              <div class="pt-qty" data-key="${safe(item.key)}">
                <button type="button" class="pt-qty__btn" data-pt-qty="-1" aria-label="${safe(dec)}">−</button>
                <input type="text" class="pt-qty__input" value="${item.quantity}" inputmode="numeric" />
                <button type="button" class="pt-qty__btn" data-pt-qty="1" aria-label="${safe(inc)}">+</button>
              </div>
              <div class="pt-cart-item__price">${PT.money(item.final_line_price)}</div>
            </div>
            <button type="button" class="pt-cart-item__remove" data-pt-remove="${safe(item.key)}">${safe(rem)}</button>
          </div>
        </article>`;
    },
    bind() {
      this.el = document.querySelector('[data-pt-cart-drawer]');
      if (!this.el) return;
      this.body = this.el.querySelector('[data-pt-cart-body]');

      // Open/close at document level (triggered from header)
      document.addEventListener('click', e => {
        const opener = e.target.closest('[data-pt-open-cart]');
        if (opener) { e.preventDefault(); this.open(); return; }
        const closer = e.target.closest('[data-pt-close-cart]');
        if (closer) { e.preventDefault(); this.close(); return; }
      });

      // Item interactions scoped to the drawer to avoid leaking into a /cart page
      this.el.addEventListener('click', e => {
        const remove = e.target.closest('[data-pt-remove]');
        if (remove) {
          e.preventDefault();
          const key = remove.getAttribute('data-pt-remove');
          PT.updateCartItem(key, 0)
            .then(cart => this.render(cart))
            .catch(j => PT.toast((j && j.description) || T('error_generic'), 'error'));
          return;
        }
        const qty = e.target.closest('[data-pt-qty]');
        if (qty) {
          e.preventDefault();
          const delta = parseInt(qty.getAttribute('data-pt-qty'), 10);
          const row = qty.closest('[data-key]');
          const key = row.getAttribute('data-key');
          const input = row.querySelector('.pt-qty__input');
          const newQty = Math.max(0, parseInt(input.value, 10) + delta);
          PT.updateCartItem(key, newQty)
            .then(cart => this.render(cart))
            .catch(j => PT.toast((j && j.description) || T('error_generic'), 'error'));
          return;
        }
      });

      // Direct qty input edits (keyboard / paste)
      this.el.addEventListener('change', e => {
        const input = e.target.closest('.pt-qty__input');
        if (!input) return;
        const row = input.closest('[data-key]');
        if (!row) return;
        const key = row.getAttribute('data-key');
        const newQty = Math.max(0, parseInt(input.value, 10) || 0);
        PT.updateCartItem(key, newQty)
          .then(cart => this.render(cart))
          .catch(j => PT.toast((j && j.description) || T('error_generic'), 'error'));
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.el.getAttribute('data-open') === 'true') this.close();
      });
    }
  };

  PT.updateCartBubble = function (count) {
    document.querySelectorAll('[data-pt-cart-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-has-items', count > 0 ? 'true' : 'false');
    });
  };

  /* ---------- Intercept add-to-cart forms ---------- */
  PT.bindAddToCart = function () {
    document.addEventListener('submit', function (e) {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.setAttribute('data-loading', 'true'); btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
        .then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)))
        .then(() => {
          if (btn) { btn.removeAttribute('data-loading'); btn.disabled = false; }
          PT.Drawer.refresh();
          PT.Drawer.open();
        })
        .catch(err => {
          if (btn) { btn.removeAttribute('data-loading'); btn.disabled = false; }
          let msg = T('error_generic') || 'Something went wrong.';
          if (err && err.status === 422) {
            msg = T('error_sold_out') || (err.description || msg);
          } else if (err && err.description) {
            msg = err.description;
          } else if (err && err.message === 'Failed to fetch') {
            msg = T('error_network') || msg;
          }
          PT.toast(msg, 'error');
        });
    });
  };

  /* ---------- Header scroll + mobile menu ---------- */
  PT.Header = {
    init() {
      const header = document.querySelector('[data-pt-header]');
      if (!header) return;
      const onScroll = () => {
        header.setAttribute('data-scrolled', window.scrollY > 20 ? 'true' : 'false');
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      document.addEventListener('click', e => {
        const toggle = e.target.closest('[data-pt-mobile-toggle]');
        if (toggle) {
          e.preventDefault();
          const open = header.getAttribute('data-menu') !== 'open';
          header.setAttribute('data-menu', open ? 'open' : 'closed');
          document.body.classList.toggle('pt-no-scroll', open);
        }
        const closer = e.target.closest('[data-pt-mobile-close]');
        if (closer) {
          header.setAttribute('data-menu', 'closed');
          document.body.classList.remove('pt-no-scroll');
        }
      });
    }
  };

  /* ---------- Announcement bar slider ---------- */
  PT.Announce = {
    init() {
      const bar = document.querySelector('[data-pt-announce]');
      if (!bar) return;
      const slides = bar.querySelectorAll('[data-pt-announce-slide]');
      if (slides.length < 2) return;
      let i = 0;
      slides[0].setAttribute('data-active', 'true');
      setInterval(() => {
        slides[i].setAttribute('data-active', 'false');
        i = (i + 1) % slides.length;
        slides[i].setAttribute('data-active', 'true');
      }, 4200);
    }
  };

  /* ---------- Scroll reveal ---------- */
  PT.Reveal = {
    init() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.pt-reveal').forEach(el => el.classList.add('is-in'));
        return;
      }
      const io = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
      document.querySelectorAll('.pt-reveal').forEach(el => io.observe(el));
    }
  };

  /* ---------- Testimonial carousel ---------- */
  PT.Carousel = {
    init() {
      document.querySelectorAll('[data-pt-carousel]').forEach(root => {
        const track = root.querySelector('[data-pt-carousel-track]');
        const prev = root.querySelector('[data-pt-carousel-prev]');
        const next = root.querySelector('[data-pt-carousel-next]');
        if (!track) return;
        const step = () => Math.min(track.clientWidth * 0.85, 360);
        prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      });
    }
  };

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    PT.Drawer.bind();
    // Skip eager refresh — the Liquid-rendered cart count + subtotal are accurate on page load.
    // The drawer fetches /cart.js only when opened or after an add/qty change.
    PT.bindAddToCart();
    PT.Header.init();
    PT.Announce.init();
    PT.Reveal.init();
    PT.Carousel.init();
  });
})();
